import { recentWishListsStyles } from "@insite/content-library/Widgets/Common/RecentWishLists";
import { GridOffset } from "@insite/mobius/GridContainer";
import { COLORS } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(recentWishListsStyles, {
    cardList: {
        gridContainer: {
            gap: 0,
            css: css`
                > ${GridOffset} {
                    padding: 0;
                }
            `,
        },
    },
    noOrdersFoundGridItem: {
        css: css`
            border-top: 1px solid ${COLORS.border.base};
            padding-top: 20px;
        `,
    },
    wishListCard: {
        gridContainer: { gap: 0 },
        wishListInfoGridItem: {
            width: [9, 9, 12, 8, 8],
            align: "middle",
        },
        wishListInfoGridContainer: { gap: 0 },
        basicInfoGridItem: {
            width: 12,
            css: css`
                margin-bottom: 10px !important;
            `,
        },
        basicInfoGridContainer: { gap: 0 },
        extendedInfoGridItem: { width: 12 },
        extendedInfoGridContainer: { gap: 0 },
        productImagesGridItem: {
            width: 12,
            css: css`
                justify-content: flex-start !important;
            `,
        },
        sharingStatusGridItem: { width: 0 },
        actionGridItem: {
            width: [3, 3, 12, 4, 4],
            align: "middle",
            css: css`
                justify-content: flex-end;
            `,
        },
    },
});
